var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InsuranceDisplayCards',{attrs:{"products":_vm.productsForCards,"placeholder":"jss-products"}}),_c('CategorizedInsurancesCard',{attrs:{"categories":_vm.productCategories,"placeholder":"jss-products"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }